import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { SuggestTitleService } from 'src/app/Service/Suggest/SuggestTitle.service';

@Component({
  selector: 'app-SuggestTitleList',
  templateUrl: './SuggestTitleList.component.html',
  styleUrls: ['./SuggestTitleList.component.scss']
})
export class SuggestTitleListComponent implements OnInit {
  Filter_title:string=""
  page:number=0;
  Procssing:boolean=false

  modalRef_Delete: any;

  constructor(
    private Suggest_Service:SuggestTitleService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }


  DataList_Suggest:Array<General_Interface>=[]
  Data_Seleted_Delete:General_Interface=Empty_General_Interface()

  ngOnInit() {
    this.Nav_Service.CheckValidPage(2179).subscribe(
      data=>{
        this.ReadData_Suggest()
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

  ReadData_Suggest(){
    this.Procssing=true
    this.Suggest_Service.GetRecord().subscribe(
      data=>{
        this.DataList_Suggest=data
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }

  Delete(item:General_Interface){
    item.DeletingProccess=true
    this.modalRef_Delete.hide()
    this.Suggest_Service.DeleteSuggest(item.id).subscribe(
      data=>{
        if(item.del==false)
          this.Alertify_Service.SuccessMessage("غیرفعال شد")
        else
          this.Alertify_Service.SuccessMessage("فعال شد")
        this.ReadData_Suggest()
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  openModal(template: TemplateRef<any>,Record) {
    this.Data_Seleted_Delete=Record
    this.modalRef_Delete = this.modalService.show(template);
  }
}
